// @ts-nocheck
import React, { useState, useEffect, useContext } from 'react';
import Router, {useRouter} from 'next/router';
import SCInput from '@/components/sc-controls/form-controls/sc-input';
import SCCheckbox from '@/components/sc-controls/form-controls/sc-checkbox';
import Button from '@/components/button';
import { colors, layout} from '@/theme';
import Fetch from '@/utils/Fetch';
import ToastContext from '@/utils/toast-context';
import * as Enums from '@/utils/enums';
import SettingsMenu from '@/components/settings/menu';
import Helper from '@/utils/helper';
import ConfirmAction from '@/components/modals/confirm-action';
import OptionService from '@/services/option/option-service';
import Storage from '@/utils/storage';
import FieldSettings from "@/PageComponents/Settings/Field Settings/FieldSettings";
import {Space, Title} from "@mantine/core";
import { createFileRoute } from '@tanstack/react-router'



function ProductSettings(props: any) {

  const router = useRouter()


  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);
  const getAccessStatus = () => {
    let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  }

  useEffect(() => {
    getAccessStatus();
  }, []);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace,"/");
    }
  }, [accessStatus]);


  return (
      <>
        <div className="settings-container">
          {/*<div className="row">
        <div className="title">
          <Breadcrumbs
            crumbs={[
              { text: 'Settings', link: '/settings', suppressLink: true },
              { text: 'Asset', link: '/settings/asset/manage' },
            ]}
          />
        </div>
      </div>*/}
          <div className="row">
            <SettingsMenu urlPath={router.asPath}/>
            <div className="settings-card">
              <Title order={2} c={'scBlue.9'}>Asset Settings</Title>

              <FieldSettings module={Enums.Module.Asset} />

              {/*<div className="row">
                <div className="column">
                  <h2>Asset Settings</h2>
                </div>
                <div className="column column-end">
                  <Button
                      disabled={accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess}
                      text={submitting ? "Saving" : "Save"} extraClasses="auto save" onClick={saveSettings}/>
                </div>
              </div>
              {groupNames.map(function (groupName, index) {
                return (
                    <div key={index}>
                      <div className="section-title">
                        {groupName}
                      </div>
                      {getSettingDetails(groupName).map(item => {
                        return item();
                      })}
                    </div>
                )
              })}*/}
            </div>
          </div>

          {/*<ConfirmAction options={confirmOptions} setOptions={setConfirmOptions}/>*/}
          <Space h={80} />

          <style jsx>{`
        .row {
            display: flex;
            justify-content: space-between;
        }
        .column {
          display: flex;
          flex-direction: column;
          width: ${layout.inputWidth};
        }
        .column-end {
          align-items: flex-end;
        }
        .column-margin {
          margin-left: 24px;
        }        
        .title {
          color: ${colors.darkPrimary};
          position: relative;
          width: 100%;
        }
        .title h1 {
          font-size: 24px;
          margin: 6px 0 2rem 0;
        }
        .title p {
          font-size: 14px;
          margin: 0;
        }       
        .section-title {
          background-color: ${colors.background};
          border-radius: ${layout.cardRadius};
          box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
          color: ${colors.bluePrimary};
          font-size: 1.25rem;
          font-weight: bold;
          margin-top: 2rem;
          opacity: 0.9;
          padding: 1rem;
        }
        .small-title {
          color: ${colors.white};
          font-size: 0.875rem;
          font-weight: bold;
          margin-top: 2rem;
        }
        .container :global(.input-container) {
          width: 50%;
        }
        .title :global(.save) {
          margin: 0;
          position: absolute;
          right: 0;
          top: 0;
        }
      `}</style>
        </div>
      </>
  );
}

export default ProductSettings;

export const Route = createFileRoute('/_authenticated/settings/asset/manage')({ component: ProductSettings })
